export const NOVIDADES_SUPPORT_URL =
  "https://atendimento.cliente.lifeapps.com.br/helpcenter/SUP/";

export const NOVIDADES_PORTAL_PATH = "/fornecedor/novidades";
